import React from 'react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { TabNavigation } from '../../components/operations/TabNavigation';
import { ChevronDown, AlertTriangle, AlertCircle } from 'lucide-react';
const MENU_TABS = [{
  label: 'Products',
  path: ''
}, {
  label: 'Categories',
  path: 'categories'
}, {
  label: 'Modifiers',
  path: 'modifiers'
}, {
  label: 'Combos',
  path: 'combos'
}, {
  label: 'Stock',
  path: 'stock'
}, {
  label: 'Promotions',
  path: 'promotions'
}, {
  label: 'Performance',
  path: 'performance'
}];
const OUT_OF_STOCK = [{
  name: 'Classic Burger',
  category: 'Burgeri',
  location: 'Vračar',
  since: '2 hours ago'
}, {
  name: 'Greek Salad',
  category: 'Salate',
  location: 'All',
  since: 'Yesterday'
}, {
  name: 'Chocolate Cake',
  category: 'Desserts',
  location: 'BB, NB',
  since: '3 hours ago'
}];
const LOW_STOCK = [{
  name: 'BIG Double Butter Smash',
  category: 'Burgeri',
  location: 'Vračar',
  note: 'Low on buns'
}, {
  name: 'Strawberry Pancake',
  category: 'Palačinke',
  location: 'All',
  note: 'Few left'
}, {
  name: 'Giros Large',
  category: 'Giros',
  location: 'NB',
  note: 'Low meat'
}, {
  name: 'Caesar Salad',
  category: 'Salate',
  location: 'BB',
  note: 'No croutons'
}];
const LOGS = [{
  time: '14:32',
  product: 'Classic Burger',
  change: '● → 🔴 Out',
  by: 'Marko S.'
}, {
  time: '14:15',
  product: 'Veggie Wrap',
  change: '🔴 → ● Back',
  by: 'Ana P.'
}, {
  time: '12:45',
  product: 'Greek Salad',
  change: '● → 🔴 Out',
  by: 'Jovana K.'
}];
export function Stock() {
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-1606">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-1607">
        <h1 className="text-2xl font-bold text-text-primary" data-id="element-1608">
          Stock Management
        </h1>
        <div className="flex items-center gap-3" data-id="element-1609">
          <button className="flex items-center gap-2 px-3 py-2 bg-background-elevated rounded-lg text-sm font-medium hover:bg-white/5 transition-colors" data-id="element-1610">
            All Locations <ChevronDown size={14} data-id="element-1611" />
          </button>
          <button className="flex items-center gap-2 px-3 py-2 bg-background-elevated rounded-lg text-sm font-medium hover:bg-white/5 transition-colors" data-id="element-1612">
            All Status <ChevronDown size={14} data-id="element-1613" />
          </button>
        </div>
      </div>

      <TabNavigation tabs={MENU_TABS} basePath="/menu" data-id="element-1614" />

      {/* Summary Cards */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-1615">
        <Card className="p-4 text-center" data-id="element-1616">
          <div className="text-sm text-text-secondary mb-1" data-id="element-1617">Total Products</div>
          <div className="text-2xl font-bold" data-id="element-1618">247</div>
        </Card>
        <Card className="p-4 text-center" data-id="element-1619">
          <div className="text-sm text-text-secondary mb-1" data-id="element-1620">In Stock</div>
          <div className="text-2xl font-bold text-accent-success" data-id="element-1621">238</div>
          <div className="text-xs text-text-secondary" data-id="element-1622">96.4%</div>
        </Card>
        <Card className="p-4 text-center" data-id="element-1623">
          <div className="text-sm text-text-secondary mb-1" data-id="element-1624">Low Stock</div>
          <div className="text-2xl font-bold text-accent-warning" data-id="element-1625">6</div>
          <div className="text-xs text-accent-warning" data-id="element-1626">⚠️ Attention</div>
        </Card>
        <Card className="p-4 text-center" data-id="element-1627">
          <div className="text-sm text-text-secondary mb-1" data-id="element-1628">Out of Stock</div>
          <div className="text-2xl font-bold text-accent-error" data-id="element-1629">3</div>
          <div className="text-xs text-accent-error" data-id="element-1630">🔴 Action needed</div>
        </Card>
      </div>

      <div className="space-y-8" data-id="element-1631">
        {/* Out of Stock Table */}
        <div data-id="element-1632">
          <h3 className="font-bold text-accent-error mb-4 flex items-center gap-2" data-id="element-1633">
            <AlertCircle size={18} data-id="element-1634" /> OUT OF STOCK ({OUT_OF_STOCK.length})
          </h3>
          <Card noPadding data-id="element-1635">
            <table className="w-full text-sm" data-id="element-1636">
              <thead data-id="element-1637">
                <tr className="text-text-secondary border-b border-white/5" data-id="element-1638">
                  <th className="text-left p-4" data-id="element-1639">PRODUCT</th>
                  <th className="text-left p-4" data-id="element-1640">CATEGORY</th>
                  <th className="text-left p-4" data-id="element-1641">LOCATION</th>
                  <th className="text-left p-4" data-id="element-1642">SINCE</th>
                  <th className="text-right p-4" data-id="element-1643">ACTION</th>
                </tr>
              </thead>
              <tbody data-id="element-1644">
                {OUT_OF_STOCK.map((item, i) => <tr key={i} className="border-b border-white/5 last:border-0 hover:bg-white/5" data-id="element-1645">
                    <td className="p-4 font-bold" data-id="element-1646">{item.name}</td>
                    <td className="p-4 text-text-secondary" data-id="element-1647">{item.category}</td>
                    <td className="p-4" data-id="element-1648">{item.location}</td>
                    <td className="p-4 text-text-secondary" data-id="element-1649">{item.since}</td>
                    <td className="p-4 text-right" data-id="element-1650">
                      <Button size="sm" variant="secondary" data-id="element-1651">
                        Back in Stock
                      </Button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </Card>
        </div>

        {/* Low Stock Table */}
        <div data-id="element-1652">
          <h3 className="font-bold text-accent-warning mb-4 flex items-center gap-2" data-id="element-1653">
            <AlertTriangle size={18} data-id="element-1654" /> LOW STOCK ({LOW_STOCK.length})
          </h3>
          <Card noPadding data-id="element-1655">
            <table className="w-full text-sm" data-id="element-1656">
              <thead data-id="element-1657">
                <tr className="text-text-secondary border-b border-white/5" data-id="element-1658">
                  <th className="text-left p-4" data-id="element-1659">PRODUCT</th>
                  <th className="text-left p-4" data-id="element-1660">CATEGORY</th>
                  <th className="text-left p-4" data-id="element-1661">LOCATION</th>
                  <th className="text-left p-4" data-id="element-1662">NOTE</th>
                  <th className="text-right p-4" data-id="element-1663">ACTION</th>
                </tr>
              </thead>
              <tbody data-id="element-1664">
                {LOW_STOCK.map((item, i) => <tr key={i} className="border-b border-white/5 last:border-0 hover:bg-white/5" data-id="element-1665">
                    <td className="p-4 font-bold" data-id="element-1666">{item.name}</td>
                    <td className="p-4 text-text-secondary" data-id="element-1667">{item.category}</td>
                    <td className="p-4" data-id="element-1668">{item.location}</td>
                    <td className="p-4 text-text-secondary italic" data-id="element-1669">
                      {item.note}
                    </td>
                    <td className="p-4 text-right" data-id="element-1670">
                      <Button size="sm" variant="secondary" className="text-accent-error hover:text-accent-error hover:bg-accent-error/10" data-id="element-1671">
                        Mark Out
                      </Button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </Card>
        </div>

        {/* Logs */}
        <div data-id="element-1672">
          <h3 className="font-bold text-text-secondary uppercase tracking-wider text-sm mb-4" data-id="element-1673">
            Recent Stock Changes
          </h3>
          <Card noPadding data-id="element-1674">
            <table className="w-full text-sm" data-id="element-1675">
              <thead data-id="element-1676">
                <tr className="text-text-secondary border-b border-white/5" data-id="element-1677">
                  <th className="text-left p-4" data-id="element-1678">TIME</th>
                  <th className="text-left p-4" data-id="element-1679">PRODUCT</th>
                  <th className="text-left p-4" data-id="element-1680">CHANGE</th>
                  <th className="text-left p-4" data-id="element-1681">BY</th>
                </tr>
              </thead>
              <tbody data-id="element-1682">
                {LOGS.map((log, i) => <tr key={i} className="border-b border-white/5 last:border-0 hover:bg-white/5" data-id="element-1683">
                    <td className="p-4 font-mono text-text-secondary" data-id="element-1684">
                      {log.time}
                    </td>
                    <td className="p-4 font-medium" data-id="element-1685">{log.product}</td>
                    <td className="p-4" data-id="element-1686">{log.change}</td>
                    <td className="p-4 text-text-secondary" data-id="element-1687">{log.by}</td>
                  </tr>)}
              </tbody>
            </table>
          </Card>
        </div>
      </div>
    </div>;
}